
define('ldsh!modules/templates/templates/templates_list', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="ed-templates-header">\n  <h3 class="ed-h-delta" data-i18n="templates.chooseTemplateFor"></h3>\n</div>\n<div class="ed-grid js-container">\n</div>\n';

}
return __p
};});

